import React, { Component } from 'react';
import './Navigation.css';

import Scroll from 'react-scroll';
import { Link } from 'react-router';

class Navigation extends Component {


    constructor(props) {
        super(props);
        this.state = {
            activeIdx: 0,
            isVisible: false
        };

        //this.Link       = Scroll.Link;
        this.scroll     = Scroll.animateScroll;

    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    componentDidUpdate() {

    };


    onClick = (e) =>  {
        ////console.log((" - onClick: " + e.target);
        this.setState({isVisible: false});
    }

    onButtonClick = (type, id) =>  {
        //console.log((" - onButtonClick: type " + type + " id: " + id);
        if (typeof this.props.onButtonClick === 'function') {
            this.props.onButtonClick(type, id);
        }
    }

    handleSetActive = (e) =>  {
        //console.log((" - handleSetActive: currentTarget " + e.currentTarget);
    }


    toggleNav = (e) =>  {
        e.preventDefault();
        this.setState({isVisible: !this.state.isVisible});
    };


    getButton = (btn, level, type) => {
        if (type === "button") {
            let clickFunc = this.onButtonClick.bind(this, type, btn.id);
            return (
                <a
                    key={btn.id + level.toString()}
                    onClick={clickFunc}
                    className={"BtnLevel" + level.toString()}
                >
                    <span>{btn.title}</span>
                </a>
            );
        } else {
            //const Link = this.Link;
            return (
                <Link
                    key={btn.id + level.toString()}
                    className={"BtnLevel" + level.toString()}
                    to={btn.id}
                >
                    <span>{btn.title}</span>
                </Link>
            );
        }
    }

    render() {
        if (this.props.buttons === undefined) return null;

        //const Link = this.Link;

        var  btns = this.props.buttons.map((btn) =>
            <Link
                key={btn.id}
                to={btn.id}
                activeClassName="activeLink"
            >
                <span>{btn.title}</span>
            </Link>
        );

        var btnsMobile = [];
        for (var i=0; i<this.props.buttons.length; i++) {
            var btn = this.props.buttons[i];
            btnsMobile.push(this.getButton(btn, 0, btn.type));
            if (btn.buttons !== undefined && btn.buttons.length > 0) {
                for (var j=0; j<btn.buttons.length; j++) {
                    var subBtn = btn.buttons[j];
                    btnsMobile.push(this.getButton(subBtn, 1, subBtn.type));
                }
            }
        }

        return (
          <div className="Navigation">
              <div className={this.props.className}>

                  <nav className="ButtonsDesktop">
                      {btns}
                  </nav>

                  <nav className="ButtonsMobile" onClick={this.toggleNav}>
                      <div className={"MenuMobile " + (this.state.isVisible ? 'activeMenu' : 'inactiveMenu')}>
                          <div className={"Background " + (this.state.isVisible ? 'showMenu' : 'hideMenu')}></div>
                            <div className={"MenuPanel " + (this.state.isVisible ? 'showPanel' : 'hidePanel')}>
                                <a onClick={this.props.onBookingClick} className="Button ButtonBuchenMenu"><i className="Icon material-icons">hotel</i> Jetzt Zimmer buchen</a>
                                <div className="ButtonContainer">
                                    {btnsMobile}
                                </div>
                            </div>
                      </div>
                  </nav>
                  <div className="BurgerMenu">
                      <div className="BurgerButton" onClick={this.toggleNav}>
                          <div className="BurgerRows">
                              <div className="BurgerRow BurgerRow-01"></div>
                              <div className="BurgerRow BurgerRow-02"></div>
                              <div className="BurgerRow BurgerRow-03"></div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js